export class VehicleModel {
  vehicleId: number = 0;
  branchId: number = 0;
  code: number = 0;
  description: string = '';
  plate: string = '';
  capacity: number | null = 0;
  conceptId: number = 0;
  departmentId: number = 0;
  cityId: number = 0;
  active: boolean = true;
  swExternal: boolean = false;
  storeId: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
